import styled from 'styled-components';
import { ArrowForward } from '@carvana/showroom-carousel/icons';
import DollarIcon from '../../../../assets/dollar-icon';
import NativeLink from '../../../common/NativeLink';

const LoanDetailsWrapper = styled.div`
  align-content: left;
  width: 100%;
  padding: 25px 0 20px;
`;

const LoanDetailsLink = styled(NativeLink)`
  &:focus,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
    color: initial;
  }
  text-decoration: none;
  display: flex;

  & :hover {
    cursor: pointer;
  }
`;

const LoanDetailsTextWrapper = styled.div`
  display: flex;
  flex-grow: 2;
  margin: 0 15px;
  flex-direction: column;
  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    margin: 0;
  }
`;

const LoanDetailsLinkBody = styled.p`
    color: ${(props) => props.theme.color.neutral.v500};
    font-weight: ${(props) => props.theme.font.weight.v100};
    ${(props) => props.theme.font.subhead.v400}};
    margin: 0;
`;

const LoanDetailsLinkTitle = styled.h5`
  color: ${(props) => props.theme.color.primary.v600};
  ${(props) => props.theme.font.subhead.v500};
  font-weight: ${(props) => props.theme.font.weight.v300};
  margin: 0 0 5px 0;
`;

const MyCarsArrowForward = styled(ArrowForward)`
  color: ${(props) => props.theme.color.primary.v200};
  flex-grow: 0;
  align-self: center;
  margin: 0;
`;

const MyCarsDollarIcon = styled(DollarIcon)`
  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    display: flex;
  }
`;

const DollarSignWrapper = styled.div`
  align-items: center;
  display: flex;
  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    display: none;
  }
`;

export {
  LoanDetailsWrapper,
  LoanDetailsLink,
  LoanDetailsLinkBody,
  LoanDetailsTextWrapper,
  LoanDetailsLinkTitle,
  MyCarsArrowForward,
  MyCarsDollarIcon,
  DollarSignWrapper,
};
